<template>
  <h1 class="title-for-search-result-list">
    {{ title }}
  </h1>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.title-for-search-result-list {
  font-feature-settings: "palt";
  font-size: 20px;
  margin-bottom: 1.5rem;

  @include sp {
    font-size: 18px;
  }
}
</style>